import "./AdminHomePage.css";
import logo_dark from "../../img/logo_dark.png";

const AdminHomePage = () => {
  return (
    <div>
      <div className="centered-container">
        <img src={logo_dark} alt="Logo" />
      </div>
    </div>
    
  );
};

export default AdminHomePage;
